/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Autocomplete constants
 */

export const AUTOCOMPLETE_ADDRESS = 'address'
export const AUTOCOMPLETE_BUILDING = 'building'
export const AUTOCOMPLETE_CITY = 'city'
export const AUTOCOMPLETE_NEIGHBORHOOD = 'hood'
export const AUTOCOMPLETE_POI = 'poi'
export const AUTOCOMPLETE_POSTCODE = 'postcode'
export const AUTOCOMPLETE_PARK = 'park'
export const AUTOCOMPLETE_BUS = 'bus'
export const AUTOCOMPLETE_TRAIN = 'train'
export const AUTOCOMPLETE_GROCERY = 'grocery'
export const AUTOCOMPLETE_RESTAURANT = 'restaurant'
export const AUTOCOMPLETE_SCHOOL = 'school'
export const AUTOCOMPLETE_NIGHTLIFE = 'nightlife'
export const AUTOCOMPLETE_RAPID_TRANSIT = 'rapid_transit'
export const AUTOCOMPLETE_CAFE = 'cafe'
export const AUTOCOMPLETE_SHOPPING = 'shopping'
/** @deprecated */
export const MAX_SEARCH_RESULTS = 4
export const MIN_CHARACTER_COUNT = 3
export const LAT_LNG_MAX_DECIMALS = 1
export const AUTOCOMPLETE_INPUT_ID = 'autocomplete-search-input'

export const NEW_YORK_BOROUGHS_URLS = {
  'new-york-ny/bronx': 'the-bronx-ny',
  'new-york-ny/manhattan': 'manhattan-ny',
  'new-york-ny/queens': 'queens-ny',
  'new-york-ny/staten-island': 'staten-island-ny',
  'new-york-ny/brooklyn': 'brooklyn-ny',
} as const

export const NEW_YORK_BOROUGHS_KEY_ARRAY = Object.keys(NEW_YORK_BOROUGHS_URLS)

export type AutocompleteOrigin =
  | 'affordability'
  | 'Bottom Search'
  | 'FOR_YOU'
  | 'nearme'
  | 'origin'
  | 'origin-fixed'
  | 'short-term'
  | 'Long-term'
  | 'Short-term'
  | 'homepage-hero'

export interface AutocompleteTheme {
  backBtn?: string
  children?: string
  closeButton?: string
  container?: string
  contextualMenu?: string
  hover?: string
  input?: string
  inputBtn?: string
  inputBtnsContainer?: string
  label?: string
  leaseLengthInput?: string
  locationIcon?: string
  locationInfo?: string
  mobileInputContainer?: string
  primaryText?: string
  recentSearchHeader?: string
  spinnerIcon?: string
  searchForm?: string
  searchFormModal?: string
  searchIcon?: string
  show?: string
}
